import User from './User'
import Menu from './Menu'
import UserTypeGroup from './UserTypeGroup'
import Privacy from './Privacy'
import PrivacyCheck from './PrivacyCheck'
import Running from './Running'
import Token from './Token'
import FileUpload from './FileUpload'
import Shop from './Shop'
import ListShop from './ListShop'
import EditShop from './EditShop'
import ListMember from './ListMember'
import VgroupMapCoin from './VgroupMapCoin'
import ManageShop from './ManageShop'
import ListAllShop from './ListAllShop'
import Errorpage from './Errorpage'
import GivePoints from './GivePoints'
import ManageApi from './ManageApi'
import Transport from './Transport'
import friendgetfriend from './friendgetfriend'
import link from './link'
import pointFree from './pointFree'
import customField from './customField'
import pay from './pay'
import confirmPayment from './confirmPayment'
// import pointFree1 from './pointFree1'
import NotifySetting from './NotifySetting'
import UpdateNotify from './UpdateNotify'
import CreateLineOAaccount from './CreateLineOAaccount'
import Register from './Register'
import connectService from './connectService'
import LINEConfigSendMessage from './LINEConfigSendMessage'
import MigrateToV2 from './MigrateToV2'

export default {
  User,
  Menu,
  UserTypeGroup,
  Privacy,
  PrivacyCheck,
  Running,
  Token,
  FileUpload,
  Shop,
  ListShop,
  ListMember,
  EditShop,
  VgroupMapCoin,
  ManageShop,
  ListAllShop,
  Errorpage,
  GivePoints,
  ManageApi,
  Transport,
  friendgetfriend,
  link,
  pointFree,
  customField,
  pay,
  confirmPayment,
  //   pointFree1,
  NotifySetting,
  UpdateNotify,
  CreateLineOAaccount,
  Register,
  connectService,
  LINEConfigSendMessage,
  MigrateToV2
}



// WEBPACK FOOTER //
// ./src/components/System/index.js